import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout = () => {
    return (
        <>
            <marquee direction="left">
                <p style={{ color: "black" }}> 
                    <b>Admission Open for New Session 2025-26 in Saraswati Vidyapeeth Higher Secondary School - Satna with the best facilities.</b>
                </p>
            </marquee>
            <section className="about-section-1 section-padding fix" style={{ marginTop: "-80px" }}>
                <div className="container">
                    <div className="about-wrapper">
                        <div className="row g-4 align-items-center">
                            <div className="col-lg-6">
                                <div className="about-content">
                                    <div className="section-title">
                                        <span className="sub-title wow fadeInUp">About Us</span>
                                        <h2 style={{ fontSize: "24px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Saraswati Vidyapeeth HR. SEC. School Experience
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s" style={{ textAlign: "justify" }}>
                                            Every student succeeds in the classroom and on the field at Saraswati Vidyapeeth HR. SEC. School because we revolutionize education by fusing academic brilliance with a sports-centric approach. In addition to providing top-notch sports training, our CBSE curriculum cultivates a culture of leadership, discipline, and curiosity.
                                        </p>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s" style={{ textAlign: "justify" }}>
                                            With cutting-edge facilities, knowledgeable coaching, and a customized educational path, we give students the tools they need to succeed academically, become experts in their sport, and create an endless future. Learning at Saraswati Vidyapeeth HR. SEC. School is about more than simply grades; it's about developing oneself holistically, gaining self-assurance, and realizing one's full potential.
                                        </p>
                                    </div>
                                    {/* <div className="about-list-item wow fadeInUp" data-wow-delay=".7s">
                                        <ul className="list">
                                            <li>
                                                <img src="assets/img/icon/cheak.svg" alt="img" />
                                                fully CCTV Campus
                                            </li>
                                            <li>
                                                <img src="assets/img/icon/cheak.svg" alt="img" />
                                                20-25 Student in each Classroom
                                            </li>
                                        </ul>
                                        <ul className="list">
                                            <li>
                                                <img src="assets/img/icon/cheak.svg" alt="img" />
                                                Hygienic lunch facility
                                            </li>
                                            <li>
                                                <img src="assets/img/icon/cheak.svg" alt="img" />
                                                Lifetime Access
                                            </li>
                                        </ul>
                                    </div> */}
                                    <div className="about-button wow fadeInUp" data-wow-delay=".3s">
                                        <Link to="/about" className="theme-btn">More About Us <i className="fa-solid fa-arrow-right" /></Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about-image">
                                    <img src="assets/img/svp/about1.png" alt="img" className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                    <div className="top-shape">
                                        <img src="assets/img/shape/about-1.png" alt="img" />
                                    </div>
                                    <div className="dot-shape float-bob-y">
                                        <img src="assets/img/shape/dot-shape.png" alt="img" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default HomeAbout